import { BaseFiltroPagDTO, IdNomeDTO } from './base-dto';

export class ModeloListItemDTO {
  id: Number;
  codigo: string;
  nome: string;
  ativo: boolean;
  compartimentos: Number;
  capacidadeMl: Number;
  capacidadeMlFormat: string;
  alteradoPor: string;
  ultimaAlteracao: Date;
}

export class FiltroModeloParmDTO extends BaseFiltroPagDTO {
  nome: String;
  ativo: boolean;
}

export class ModeloParmDTO {
  id: Number;
  codigo: string;
  nome: string;
  ativo: boolean;
  compartimentos: CompartimentoParmDTO[] = [];
}

export class ModeloDTO extends ModeloParmDTO {
    capacidadeMl: Number;
    capacidadeMlFormat: string;
    alteradoPor: string;
    ultimaAlteracao: Date;
    compartimentos: CompartimentoDTO[] = []
    alerta:string;
}

export class CompartimentoParmDTO {
  letra: string;
  capacidadeMl: Number;
  idsProdutos: Number[] = [];
}

export class CompartimentoDTO extends CompartimentoParmDTO {
  id: Number;
  capacidadeMlFormat: string;
  produtos: IdNomeDTO[];
}
